// extracted by mini-css-extract-plugin
module.exports = {"labelTextContent":"styles_labelTextContent__5Mkxd","labelSponsorLink":"styles_labelSponsorLink__LTK_s"};